import { Component, OnInit } from '@angular/core';
import { ContextService } from '../context.service';

@Component({
    selector: 'mutara-aup',
    templateUrl: './aup.component.html',
    styleUrls: ['./aup.component.scss'],
    standalone: false
})
export class AupComponent implements OnInit {
  baseUrl : string;

  constructor(private context : ContextService) { 
    
    this.baseUrl = window.location.href;
  }

  ngOnInit(): void {
    this.context.showProgress(false);
    this.context.setSubTitle('Acceptable Use Policy');
  }

}
